import { gql } from '@apollo/client';
import React from 'react';
import classNames from 'classnames';
import { DesktopSiteNavPulldownFragment } from '../../generated/types/DesktopSiteNavPulldownFragment';
import {
  DESKTOP_SITE_NAV_LIST_COLUMN_FRAGMENT,
  DesktopSiteNavListColumn
} from './DesktopSiteNavListColumn';
import {
  DESKTOP_SITE_NAV_IMAGE_COLUMN_FRAGMENT,
  DesktopSiteNavImageColumn
} from './DesktopSiteNavImageColumn';
import './DesktopSiteNavPulldown.scss';

export const DESKTOP_SITE_NAV_PULLDOWN_FRAGMENT = gql`
  fragment DesktopSiteNavPulldownFragment on NavItem {
    desktopChildren {
      ...DesktopSiteNavListColumnFragment
      ...DesktopSiteNavImageColumnFragment
    }
  }
  ${DESKTOP_SITE_NAV_LIST_COLUMN_FRAGMENT}
  ${DESKTOP_SITE_NAV_IMAGE_COLUMN_FRAGMENT}
`;

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  navItem: DesktopSiteNavPulldownFragment;
}

export const DesktopSiteNavPulldown: React.FC<Props> = ({ className, navItem }) => {
  return (
    <div className={classNames('DesktopSiteNavPulldown', className)}>
      {navItem.desktopChildren.map((column, i) => {
        switch (column.__typename) {
          case 'NavListColumn':
            return (
              <DesktopSiteNavListColumn
                key={i}
                className="DesktopSiteNavPulldown__column"
                navListColumn={column}
              />
            );
          case 'NavImageColumn':
            return (
              <DesktopSiteNavImageColumn
                key={i}
                className="DesktopSiteNavPulldown__column"
                navImageColumn={column}
              />
            );
        }
      })}
    </div>
  );
};
